import {
  BtnGroup,
  BtnToolbar,
  Button,
  ButtonAction,
  Check,
  Col,
  Combobox,
  Row,
  Text
} from '@dec/shared';
import { yupResolver } from '@hookform/resolvers/yup';
import { t } from 'i18next';
import { Modal } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { type ColDefinitionModel } from '../../models/Catalog';

interface PropertyForm {
  field: string;
  label: string;
  type: NameValue;
  translatable: boolean;
}

interface CatalogPropertyModalProps {
  show: boolean;
  handleCancel: () => void;
  handleFinish: (definition: ColDefinitionModel) => boolean;
}

interface NameValue {
  name: string;
  value: string;
}

export const CatalogDefinitionModal = ({
  show,
  handleCancel,
  handleFinish
}: CatalogPropertyModalProps) => {
  const handleSave = async (values: PropertyForm) => {
    // se va a guardar los datos del formulario
    const content: ColDefinitionModel = {
      field: values.field,
      label: values.label,
      type: values.type?.name as 'text' | 'bool' | 'date' | 'number',
      translatable: values.translatable
    };

    // envio la finalización con los datos guardados
    handleFinish(content);
  };

  // se configuran las validaciones del formulario, cuales son las reglas que debe cumplir
  const schema: yup.ObjectSchema<PropertyForm> = yup.object({
    field: yup.string().nullable().required(),
    label: yup.string().nullable().required(),
    type: yup.mixed<NameValue>().nullable().required(),
    translatable: yup.boolean().nullable().required()
  });

  // se construye el formulario con los valores recibiods y las reglas por aplicar
  // esto nos devuelve los métodos para su gestión (submit, reset, etc)
  const methods = useForm<PropertyForm>({
    resolver: yupResolver(schema)
  });
  // vamos a utilizar el manejo de submit y el manejo de reset
  const { handleSubmit } = methods;

  const definitionTypes: Array<NameValue> = [
    { name: 'number', value: 'number' },
    { name: 'text', value: 'text' },
    { name: 'date', value: 'date' },
    { name: 'bool', value: 'bool' }
  ];

  return (
    <Modal show={show}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleSave)} autoComplete="off">
          <Modal.Header closeButton>
            <Modal.Title>{t('catalog.fieldAdditionalAdd')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Text label={t('catalog.definitions.field')} name="field" />
              </Col>
              <Col>
                <Combobox
                  code="id"
                  display="name"
                  data={definitionTypes}
                  label={t('catalog.definitions.type')}
                  name="type"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Text label={t('catalog.definitions.label')} name="label" />
              </Col>
            </Row>
            <Row>
              <Col>
                <Check label={t('catalog.definitions.translatable')} name="translatable" />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <BtnToolbar>
              <BtnGroup>
                <Button action={ButtonAction.cancel} variant="secondary" onClick={handleCancel} />
              </BtnGroup>
              <BtnGroup>
                <Button action={ButtonAction.add} variant="primary" type={'submit'} />
              </BtnGroup>
            </BtnToolbar>
          </Modal.Footer>
        </form>
      </FormProvider>
    </Modal>
  );
};
